"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns a very basic simulated onChange event
 * object. Useful for handling non-input element
 * change events as if they were input change events.
 *
 * @param name  The name attribute of the "input" element.
 * @param value The value attribute of the "input" element.
 *
 * @returns Synthetic change event object.
 */
function simulateChangeEvent(name, value) {
    return {
        target: {
            value: value,
            getAttribute: function (attributeName) {
                return {
                    name: name,
                }[attributeName];
            },
        },
    };
}
exports.default = simulateChangeEvent;
//# sourceMappingURL=simulateChangeEvent.js.map